import { Component } from '@angular/core';
import { GlobalVariable } from '../../shared/global.settings';
import { UserManagementComponent } from '../user-management/user-management.component';


@Component({
    selector: 'layout-header',
    templateUrl: './header.component.html',
    styleUrls: [
        './header.component.scss'
    ],
    standalone: true,
    imports: [UserManagementComponent]
})
export class HeaderComponent {
  windowTitle: String = 'Initial';
  constructor(
  ) {
    this.windowTitle = GlobalVariable.APPLICATION_NAME;
  }

}
